import { createRouter, createWebHistory } from 'vue-router'
import { seal } from '@/api/encryption'
import installRouter from './permission'
import Login from '@/pages/login.vue'
import schoolHome from '@/components/schoolHome.vue'
import schoolMain from '@/components/schoolMain.vue'
import otherLogin from './module/otherLogin'
const oaExamine = () => import('@/views/clientSide/oaExamine/index')
const application = () =>import('@/components/clientSide/applicationRouting')
const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  // 手机端预览打印页面
  {
    path: '/previewTable',
    name: 'previewTable',
    component: () => import('@/pages/previewTable')
  },
  {
    path: '/clientSide/reportView',
    component: () => import('@/components/reportView/index'),
    name: '报表预览页'
  },
  {
    path: '/',
    name: 'schoolHome',
    redirect: '/index',
    component: schoolHome,
    children: [
      {
        path: '/index',
        component: schoolMain,
        name: '首页',
      },
      {
        path: '/space/index',
        component: schoolMain,
        name: '组织空间门户',
      },
      {
        path: '/space/oaExamine',
        component: oaExamine,
        name: '组织空间应用中心'
      },
      {
        path: '/upace/index',
        component: schoolMain,
        name: '个人空间门户'
      },
      {
        path: '/upace/oaExamine',
        component: oaExamine,
        name: '个人空间应用中心'
      },
      {
        path: '/clientSide/oaExamine',
        component: oaExamine,
        name: 'OA审批',
      },
      {
        path: '/personalCenter',
        component: () => import('@/components/personal/personalCenter'),
        name: '个人中心',
      },
      {
        path: '/vipCenter',
        component: () => import('@/components/common/vipPay/vipCenter'),
        name: 'VIP个人中心',
      },
      {  
        path: '/website/:skey',
        name: '官网',
        component: () => import('@/components/websiteMain.vue')
      }
    ]
  },
  //- AI小易客户端页面
  {
    path: '/chat',
    name: 'chat',
    component: () => import('@/components/clientSide/chat')
  },
  //- 应用数据导入
  {
    path: '/clientSide/workbench/TMbulkImport',
    component: () =>import('@/components/clientSide/workbench/newTMbulkImport'),
    name: '批量导入'
  },
  //- 在线预览页面
  {
    path: '/previewFile',
    name: 'previewFile',
    component: () => import('@/components/common/preview/filePreview.vue')
  },
  //- 知识库页面
  { 
    path: '/knowledgeBase', 
    name: '知识库',
    component: () => import('@/views/knowledgeBase/index')
  },
  //- 仪表盘
  {
    path: '/clientSide/instrument/instrument',
    component: () => import('@/components/clientSide/instrument/instrument'),
    name: '仪表盘工坊客户端'
  },
  {
    path: '/clientSide/workbench/CycleFillingSetting/CycleFillingSetting',
    component: () => import('@/components/clientSide/workbench/CycleFillingSetting/CycleFillingSetting'),
    name: '未填提醒客户端'
  },
  {
    path: '/clientSide/oaFrame/oaFrame',
    name: '办公框架',
    component: () => import('@/components/clientSide/oaFrame/oaFrame')
  },
  {
    path: '/organization',
    name: '组织管理',
    component: () => import('@/components/admins/organization/organization')
  },
    {
    path: '/role',
    name: '角色管理',
    component: () => import('@/components/admins/organization/organizationRole')
  },
  {
    path: '/users',
    name: '用户管理',
    component: () => import('@/components/admins/organization/organizationUser')
  },
  {
    path: '/operationLog',
    name: '用户日志',
    component: () => import('@/components/admins/organization/operationLog')
  },
  {
    path: '/customInstrument',
    name: '场景',
    component: () => import('@/components/schoolInstrument/customInstrument.vue')
  },
  {
    path: '/blockchainNodata',
    // name: 'blockchainNodata',
    component: () => import('@/components/clientSide/blockchain/blockchainNodata'),
    name: '区块链为开提醒客户端'
  },
  {
    path: '/addLogin',
    name: '添加登录',
    component: Login
  },
  //双十单点登陆
  {
    path: '/xmsslogin',
    name: 'xmsslogin',
    component: () => import('@/pages/xmsslogin')
  },
  //泉州职称单点登陆
  {
    path: '/qzzclogin',
    name: 'qzzclogin',
    component: () => import('@/pages/qzzclogin')
  },
  //集美教育局单点登陆
  {
    path: '/jmjyjlogin',
    name: 'jmjyjlogin',
    component: () => import('@/pages/jmjyjlogin')
  },
  {
    path: '/clientSide/application', component: application, name: '个人数据权限', headShow: true
  },
  {
    path: '/mission',
    component: () => import('@/views/mission/'),
    name: 'missiion',
    children: [
      {
        path: 'myFillIn', // 我发起的
        component: () => import('@/views/mission/myFillIn'),
        name: 'myFillIn',
      }, {
        path: 'processed', // 我已处理的
        component: () => import('@/views/mission/processed'),
        name: 'processed',
      }, {
        path: 'unprocessed', // 待我处理的
        component: () => import('@/views/mission/unprocessed'),
        name: 'unprocessed',
      }, {
        path: 'recipient',// 设置接收人
        component: () => import('@/views/mission/recipient'),
        name: 'recipient',
      }, {
        path: 'appraisal', // 任务评审
        component: () => import('@/views/mission/appraisal'),
        name: 'appraisal',
      }, {
        path: 'configInfo', // 任务参数设置
        component: () => import('@/views/mission/configInfo'),
        name: 'configInfo',
      },
    ]
  },
]

const routeAll = [...routes, ...otherLogin]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routeAll
})


// 重写 push 方法

const originalPush = router.push;

router.push = function push(location) {
  // 如果有 query 且不是空对象，且没有被标记为“不加密”
  if (location.query && Object.keys(location.query).length > 0 && location.path === '/customInstrument') {
    location.query = seal(location.query); 
  }
  return originalPush.call(this, location);
};

installRouter(router)

export default router
